import { Outlet } from "react-router-dom"



export default function EventDashOut() {
  return (
    <div className="blogDashboard" style={{width:"100%"}}>
   <h1>Dashbord Event Out</h1>
    <Outlet/>
        
    </div>
  )
}
